import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { consumePostAuthRedirect } from "@/lib/post-auth-redirect";

/**
 * Handles the Emergent OAuth callback. The URL looks like:
 *   /auth/callback#session_id=abc123
 * We exchange that session_id with our backend, which creates a user + session
 * and returns a session_token we store in localStorage (alongside httpOnly cookie).
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUserFromGoogle } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        // Store the session_token so axios interceptor can attach it
        localStorage.setItem("token", data.session_token);
        setUserFromGoogle({
          id: data.id,
          email: data.email,
          name: data.name,
          picture: data.picture,
          role: data.role,
        });
        toast.success(`Welcome ${data.name || data.email}`);
        navigate(consumePostAuthRedirect("/dashboard"), { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      });
  }, [navigate, setUserFromGoogle]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] text-[#6B6B6B]">
      Signing you in…
    </div>
  );
}
